// UI komponente
import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { APPLICATION_SETTINGS_PAGE_TITLE } from "ui/components/PageTitle/consts";

// Moduli specifični za projekt
import { Routes } from "ui/modules/navigation";

// Lokalne komponente
import InvoiceExtractionCard from "./components/InvoiceExtractionCard/InvoiceExtractionCard";
import { ApplicationSettingsPageCmp, ApplicationSettingsPageProps } from "./types";

/**
 * Postavke koje vrijede za cijelu aplikaciju, a ne za pojedinog tenanta. Svaka cjelina je kartica s
 * pregledom vrijednosti i gumbom koji otvara obrazac za izmjenu — isto kao postavke dokumenata.
 */
const ApplicationSettingsPage: ApplicationSettingsPageCmp = (_props: ApplicationSettingsPageProps) => {
  const title = APPLICATION_SETTINGS_PAGE_TITLE;

  return (
    <div>
      <div className="bg-white rounded-t-md border-b border-slate-200">
        <PageHeader>
          <PageTitle title={title.text} icon={title.icon} iconColor={title.iconColor} />
          <Breadcrumb />
        </PageHeader>
      </div>

      <div className="px-4 py-4">
        <InvoiceExtractionCard />
      </div>
    </div>
  );
};

ApplicationSettingsPage.route = Routes.ApplicationSettingsPageRouter;

export default ApplicationSettingsPage;
